import client from '../lib/http-client';
import { buildQuery } from '../lib/helper';

const endpoint = '/rundowns';

export default {
	// Create
	create(params, cb, errorCb) {
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		const url = `${endpoint}`;
		client.post(url, params)
			.then(responseHandler)
			.catch(errorHandler);
	},
	// Create
	duplicate(id, cb, errorCb) {
		const url = `${endpoint}/duplicate/${id}`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.post(url)
			.then(responseHandler)
			.catch(errorHandler);
	},
	/**
	 * Create Bulk
	 *
	 * @param {Object[]} users Users
	 * @param {string} users.email Email
	 * @param {string} users.password Password
	 * @param {string} users.language Language
	 * @param {string} users.firstName First Name
	 * @param {string} users.gender Gender
	 * @param {*} cb Callback
	 * @param {*} errorCb Error Callback
	 */
	createBulk(rundowns, cb, errorCb) {
		const url = `${endpoint}/bulk/create`;
		const params = { rundowns: JSON.stringify(rundowns) };
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.post(url, params)
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Get
	get(id, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.get(url)
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Get by Slug
	getBySlug(slug, cb, errorCb) {
		// console.log(slug);
		const url = `${endpoint}/slug/${slug}`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.get(url)
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Get List
	getList(params, cb, errorCb) {
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		const url = endpoint;
		client.get(url, { params })
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Bulk Delete
	bulkDelete(ids, cb, errorCb) {
		const params = {
			user_ids: JSON.stringify(ids),
			is_deleted: 1,
		};
		const url = `${endpoint}`;
		const responseHandler = (response) => {
			if (cb) {
				cb(response.data);
			}
		};
		const errorHandler = (e) => {
			if (errorCb) {
				errorCb(e);
			}
		};
		client.delete(url, { data: params })
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Update
	update(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	// 	changeBackground
	changeBackground(id, params, cb, errorCb) {
		const url = `${endpoint}/slug/${id}/background`;
		client.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	// Delete
	delete(id, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.delete(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Export Users
	exportList(type, params, cb, errorCb) {
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		const query = buildQuery(params);
		const url = `${endpoint}/export/${type}?${query}`;
		client.get(url, { responseType: 'blob' })
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Stop
	stop(slug, cb, errorCb) {
		const url = `${endpoint}/slug/${slug}/stop`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	// Stop
	stopPreview(slug, cb, errorCb) {
		const url = `${endpoint}/slug/${slug}/stopPreview`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	// Stop
	stopLive(slug, cb, errorCb) {
		const url = `${endpoint}/slug/${slug}/stopLive`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	// cache Display
	cacheDisplay(id, params, cb, errorCb) {
		const url = `${endpoint}/cacheDisplay/${id}`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// quiks start
	quickStartRundown(cb, errorCb) {
		const url = `${endpoint}/quick_start`;
		client.post(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// render rundown
	renderRundown(params, cb, errorCb) {
		const url = `${endpoint}/lottieImage`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	getRenderHistories(id, page, cb, errorCb) {
		client.get(`${endpoint}/${id}/histories`, { params: { page } })
			.then((response) => { if (cb) cb(response.data); })
			.catch((error) => { if (errorCb) errorCb(error); });
	},
	getRenderHistoryDownload(id, historyId, cb, errorCb) {
		client.get(`${endpoint}/${id}/histories/${historyId}/download`)
			.then((response) => { if (cb) cb(response.data); })
			.catch((error) => { if (errorCb) errorCb(error); });
	},
	deleteRenderHistory(id, historyId, cb, errorCb) {
		client.delete(`${endpoint}/${id}/histories/${historyId}`)
			.then((response) => { if (cb) cb(response.data); })
			.catch((error) => { if (errorCb) errorCb(error); });
	},
	// quick rundown
	getQuickRundown(cb, errorCb) {
		const url = `${endpoint}/quick/start`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
